import styles from "./MembershipFilter.module.css"
import { useMemberships } from "@/apiUtilities/queries/useMemberships"
import CustomRadio from "@/components/UI/Buttons/Radio/CustomRadio"
import { Membership } from "@/interfaces/memberships_types"
import { useLocale, useTranslations } from "next-intl"
import { useEffect, useRef, useState } from "react"

function parseMembershipValue(str: string): string {
	if (!str) return '';
	const match = str.match(/membership=([^&]+)/);
	return match ? match[1] : '';
}

interface MembershipFilterProps {
	update: (name: string, value: string) => void
	resetSignal: number
	initialData: string
}

export default function MembershipFilter({ update, resetSignal, initialData }: MembershipFilterProps) {
	const t = useTranslations("Catalogue")
	const locale = useLocale()
	const { data: membershipsData } = useMemberships(locale)
	const selectedMembership = parseMembershipValue(initialData)

	const [membership, setMembership] = useState(parseMembershipValue(initialData))
	
    useEffect(() => {
        if(membership !== '') update('membership', 'membership=' + membership)
        else update('membership','')
    }, [membership])

	useEffect(() => {
        setMembership('')
    }, [resetSignal])

	useEffect(() => {
		setMembership(parseMembershipValue(initialData))
	}, [])
	/**
	 * Handles selecting/unselecting a membership option.
	 * 
	 * If the user clicks the currently selected membership, it clears the selection.
	 * Otherwise, it sets the clicked membership as the new selection.
	 * 
	 * @param id - Membership identifier to toggle.
	 */
	function handleChange(id: string) {
		if (id === selectedMembership) {
			// update('membership', '')
			setMembership('')
			return
		} else {
			setMembership(id)
		}	// update('membership', `membership=${id}`)
	}

  	if (!membershipsData) return null

	return (
		membershipsData.memberships.length > 1 && <div data-testid="MembershipFilter">
			<h4 data-testid="MembershipFilter_title" className={`bodyTextMedium ${styles.title}`}>{t('plansTitle')}</h4>
			<div className={styles.filters} data-testid="MembershipFilter_filters">
				{membershipsData.memberships.map(membership => {
					return (
						<CustomRadio
							key={membership.membership_id}
							label={membership.title}
							id={membership.membership_id}
							name={membership.title}
							onChange={() => handleChange(membership.membership_id)}
							checked={selectedMembership === membership.membership_id}
						/>
					)
				})}
			</div>
		</div>
	)
}